import { useJackpotsStore } from '../jackpotsStore'

export const useSetJackpotsData = () => {
  return useJackpotsStore(state => [state.setJackpotsData, state.jackpotsData])
}
